import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';

export const EddDash: FC = () => {
  const { headersHugeNone } = useTheme();

  // https://github.com/narvar/nth/pull/994/files#r946119464
  const dashTheme: CSSProperties = {
    ...headersHugeNone,
    lineHeight: headersHugeNone?.lineHeight ?? '5.5rem',
    width: '2.5rem',
    textAlign: 'center',
    fontSize: '3rem',
    fontWeight: '700',
    margin: '0.5rem 0 0 0',
  };

  return <div style={dashTheme}>-</div>;
};

export default EddDash;
